import Alert from "@pathwright/ui/src/components/alert/Alert"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import React from "react"

const tPrefix = "step.completion_error"

class StepCompletionError extends React.Component {
  static displayName = "StepCompletionError"

  constructor(props) {
    super(props)

    this.state = {
      showError: true
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.completion &&
      this.props.completion &&
      nextProps.completion.last_completion_attempt_date !==
        this.props.completion.last_completion_attempt_date
    ) {
      this.setState({ showError: true })
    }
  }

  clearError = () => {
    this.setState({ showError: false })
  }

  get allowClear() {
    return !this.props.step_completion_error && !this.props.completionIsDisabled
  }

  get error() {
    const { completion, step_completion_error, completionIsDisabled, t } =
      this.props

    const baseError = t(`${tPrefix}.base`, {
      earned: completion.userpoints_earned,
      value: completion.userpoints_value,
      min: completion.minimum_passing_score
    })

    return step_completion_error
      ? step_completion_error
      : completionIsDisabled
      ? baseError
      : completion.has_failed_passing_attempt
      ? `${baseError} ${t(`${tPrefix}.re_attempt`)}.`
      : ""
  }

  render() {
    const { step_completion_error, step, completionIsDisabled } = this.props

    // If manual grading is set, don't show min. passing score message
    if (!step_completion_error && step.grading_type === "M") return null

    return (
      <div
        style={{
          maxWidth: "500px",
          margin: "0 auto"
        }}
        className="complete-step-error alert alert-danger"
      >
        {this.state.showError && (
          <Alert
            onClear={this.allowClear ? this.clearError : null}
            error={this.error}
          />
        )}
      </div>
    )
  }
}

export default withTranslate(StepCompletionError)
